import { useState } from "react";
import { Button, Flex, ModalV2, Textarea } from "@jsq/ds/core";
import { SPACING } from "~/styles/variables";
import type { CaseResolutionNoteModalProps } from "./types";

export const CaseResolutionNoteModal = ({
  isOpen,
  title,
  placeholder,
  onClose,
  onSubmit,
}: CaseResolutionNoteModalProps) => {
  const [note, setNote] = useState("");

  const trimmedNote = note.trim();

  const handleSubmit = () => {
    onSubmit(trimmedNote);
    setNote("");
    onClose();
  };

  const handleClose = () => {
    setNote("");
    onClose();
  };

  if (!isOpen) {
    return null;
  }

  return (
    <ModalV2 show={isOpen} onHide={handleClose} title={title}>
      <ModalV2.Body>
        <Flex flexDirection="column" gap={SPACING.SMALL}>
          <Textarea
            name="case-resolution-note"
            placeholder={placeholder}
            isFullWidth
            onSetValue={setNote}
            value={note}
          />
        </Flex>
      </ModalV2.Body>
      <ModalV2.Footer>
        <Flex justifyContent="flex-end" gap={SPACING.SMALL}>
          <Button variant="neutral" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit} disabled={!trimmedNote}>
            Submit
          </Button>
        </Flex>
      </ModalV2.Footer>
    </ModalV2>
  );
};
